/**
 * Navigation資料
 * @returns {Object}
 */
const state = () => ({
    to: null,
    from: null,
    prop: null,
});

const actions = {};

const getters = {};

const mutations = {
    /**
     * 清空資料
     * @param {*} state
     */
    clear(state) {
        state.to = null;
        state.from = null;
        state.prop = null;
    },

    clearTo(state){
        state.to = null;
    },

    clearFrom(state){
        state.from = null;
    },

    clearProp(state){
        state.prop = null;
    },
    
    /**
     * 設定網頁to登入資料
     * @param {*} state
     * @param {*} payload
     */
    setTo(state, payload) {
        state.to = payload;
    },
    /**
     * 設定註冊資料
     * @param {*} state
     * @param {*} payload
     */
    setFrom(state, payload) {
        state.from = payload;
    },
    setProp(state, payload){
        state.prop = null;
        if(!!payload) state.prop = payload;
    },
    setAll(state, payload){
        if(!!payload){
            if(payload.clear){
                state.to = null;
                state.from = null;
                state.prop = null;
            }

            state.to = payload.to || null;
            state.from = payload.from || null;
            state.prop = payload.prop || null;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
